import { Fragments } from "requests";

export const GENERAL_ASSESSMENT_KEYS: (keyof NonNullable<
  Fragments.StoredGeneralAssessment
>)[] = [
  "buccalMucosa",
  "caudalOralMucosa",
  "dentalChart",
  "extraoral",
  "fistula",
  "hardPalate",
  "lymphNodes",
  "occlusion",
  "occlusionDescription",
  "parulisSinusTract",
  "skullType",
  "softPalate",
  "tongue",
  "tonsils",
  "periodontalDisease",
  "plaqueIndex",
  "calculusIndex",
  "gingivalIndex",
  "additionalCommentsAndNotes",
  "beforePhotoFront",
  "beforePhotoLeft",
  "beforePhotoRight",
  "afterPhotoFront",
  "afterPhotoLeft",
  "afterPhotoRight",
  "notesTimer",
  "cbctComments",
  "intraoralRadiographicComments",
  "notesForClientDentalReport",
  "referralNotesAndComments",
  "leftInferiorAlveolar",
  "leftInfraorbital",
  "leftMaxillary",
  "leftRostralMandibular",
  "planingAndSubgingivalCurettage",
  "rightInferiorAlveolar",
  "rightInfraorbital",
  "rightMaxillary",
  "rightRostralMandibular",
  "treatmentAdditionalFindingsCommentsAndNotes",
  "between25And50PerCentBoneLoss",
  "externalCervicalToothResorption",
  "externalInflammatoryToothResorption",
  "externalReplacementRootResorption",
  "externalSurfaceRootResorption",
  "greaterThan50PerCentBoneLoss",
  "internalToothResorption",
  "lessThan25PerCentBoneLoss",
  "missingTeeth",
  "periapicalLucency",
  "periapicalRarefaction",
  "retainedToothRoots",
  "toothResorptionType1",
  "toothResorptionType2",
  "toothResorptionType3",
  "uneruptedTeeth",
  "widenedPulpCanal"
];

export const GENERAL_ASSESSMENT_ARRAY_VALUED_KEYS = [
  "leftRegionalBlocks",
  "oralSurgeries",
  "orthodontics",
  "periodontics",
  "rightRegionalBlocks",
  "additionalPhotos",
  "radiographicFindingsPhotos"
] as const;
